import { CustomPalette } from 'business/definitions';
import { camelize, snakify } from 'helpers/syntaxHelper';
import { PaletteName } from 'styles/theme';

const getColorHue = (color: string) => {
    // see https://gist.github.com/afonsograca/7316f7a74b21e386c8963fe53c82b8ae
    const hex = color.substring(1);
    /* Get the RGB values to calculate the Hue. */
    const red = parseInt(hex.substring(0, 2), 16) / 255;
    const green = parseInt(hex.substring(2, 4), 16) / 255;
    const blue = parseInt(hex.substring(4, 6), 16) / 255;

    /* Getting the Max and Min values for Chroma. */
    const max = Math.max.apply(Math, [red, green, blue]);
    const min = Math.min.apply(Math, [red, green, blue]);

    /* Variables for HSV value of hex color. */
    const chr = max - min;
    let hue = 0;
    const val = max;
    const sat = chr / val;

    if (val > 0) {
        /* Calculate Saturation only if Value isn't 0. */
        if (sat > 0) {
            if (red === max) {
                hue = 60 * ((green - min - (blue - min)) / chr);
                if (hue < 0) {
                    hue += 360;
                }
            } else if (green === max) {
                hue = 120 + 60 * ((blue - min - (red - min)) / chr);
            } else if (blue === max) {
                hue = 240 + 60 * ((red - min - (green - min)) / chr);
            }
        }
    }
    return hue;
};

export const sortColors = (colorA: string, colorB: string) =>
    getColorHue(colorA) - getColorHue(colorB);

export const getCurrentColorMapping = (
    currentPalette: CustomPalette | undefined,
    defaultPaletteName: PaletteName,
    dimensionKey: string | null | undefined,
) => {
    if (!currentPalette || !dimensionKey) {
        return [];
    }
    const colorMappingsForPalette = currentPalette[defaultPaletteName];
    if (!colorMappingsForPalette) {
        return [];
    }
    // We use the transformed key because the dimension key is snakified and then caemlized by the API
    const transformedKey = camelize(snakify(dimensionKey));
    return (
        colorMappingsForPalette[dimensionKey] ??
        colorMappingsForPalette[transformedKey] ??
        []
    );
};
